module.exports = __webpack_public_path__ + "static/media/Dominic Roberts.a065a771.png";